var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":_vm.width,"height":_vm.height,"viewBox":"0 0 10 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M5 12L0.669872 7.5L9.33013 7.5L5 12Z","fill":"#C4C4C4"}}),_c('path',{attrs:{"d":"M5 0L9.33013 4.5H0.669873L5 0Z","fill":"black"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }